export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';

export const UPDATE_MENU_LIST = 'UPDATE_MENU_LIST';

export const TOGGLE_SYSTEM_LOADING = 'TOGGLE_SYSTEM_LOADING';
